import { useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import { HiArrowLeft } from 'react-icons/hi';
import { getPostsByCategory } from '../../posts';
import { getTopic } from './config';
import { formatDate } from './utils';
import BlogHeader from './BlogHeader';
import BlogFooter from './BlogFooter';
import './blog.css';

const Topic = () => {
  const { slug } = useParams();
  const topic = getTopic(slug);
  const posts = getPostsByCategory(slug);

  const totalMinutes = posts.reduce(
    (sum, p) => sum + (parseInt(p.readTime, 10) || 0),
    0
  );
  const latestYear = posts.length
    ? new Date(posts[0].date).getFullYear()
    : '';

  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = topic ? `${topic.name} — Jonah Odoh` : 'Topic not found';
  }, [topic]);

  if (!topic) {
    return (
      <div className="blog__page">
        <BlogHeader />
        <div className="container blog__empty">
          <h2>Topic not found</h2>
          <Link to="/blog" className="post__back">
            <HiArrowLeft /> Back to the blog
          </Link>
        </div>
        <BlogFooter />
      </div>
    );
  }

  return (
    <div className="blog__page">
      <BlogHeader />

      <div className="container">
        <header className="topic__hero">
          <span className="topic__ghost" aria-hidden="true">
            {topic.name}
          </span>
          <div className="topic__hero-content">
            <span className="topic__eyebrow">Topic</span>
            <h1 className="topic__title">{topic.name}</h1>
            <p className="topic__blurb">{topic.blurb}</p>
            <div className="topic__stats">
              <div className="topic__stat">
                <strong>{String(posts.length).padStart(2, '0')}</strong>
                <span>Articles</span>
              </div>
              <div className="topic__stat">
                <strong>~{totalMinutes}</strong>
                <span>Min total</span>
              </div>
              {latestYear && (
                <div className="topic__stat">
                  <strong>{latestYear}</strong>
                  <span>Latest</span>
                </div>
              )}
              <Link to="/blog" className="topic__stat-link">
                All posts →
              </Link>
            </div>
          </div>
        </header>

        <div className="topic__list">
          {posts.length === 0 ? (
            <div className="blog__empty">No posts in this topic yet.</div>
          ) : (
            posts.map((post) => (
              <Link
                key={post.slug}
                to={`/blog/${post.slug}`}
                className="topic__row"
              >
                <div className="topic__row-no">
                  NO. {String(post.number).padStart(2, '0')}
                  <span className="topic__row-cat">{topic.name}</span>
                </div>
                <div className="topic__row-main">
                  <h2>{post.title}</h2>
                  <p>{post.excerpt}</p>
                </div>
                <div className="topic__row-meta">
                  <span>{formatDate(post.date)}</span>
                  <span>{post.readTime}</span>
                </div>
              </Link>
            ))
          )}
        </div>
      </div>

      <BlogFooter />
    </div>
  );
};

export default Topic;
